// extracted by mini-css-extract-plugin
export default {"message":"LockMessage-module__message__67zaD","content":"LockMessage-module__content__YgaXS","title":"LockMessage-module__title__c3Q8k","text":"LockMessage-module__text__cq5K2"};